function initSliderHeader(block, slider) {
  // The slide info
  const info = {
    holder: block.querySelector('.js-slider-header__info'),
    line: block.querySelector('.js-slider-header__line'),
    count: block.querySelector('.js-slider-header__count')
  };

  // controls
  const controls = {
    prev: block.querySelector('.js-slider-header__prev'),
    next: block.querySelector('.js-slider-header__next')
  };

  // Find the tns controls
  const tnsControls = block.querySelector('.tns-controls') || false;
  const Observer = new MutationObserver(() => {
    // When there is a mutation, we need to hide / show the controls and info elements
    showHide();
  });
  const showHide = () => {
    // If there are no tns controls dont bother
    if (!tnsControls) return;

    // Check if the tnsControls have the style "display: none" inline
    const isHidden = tnsControls.style.display === 'none';

    // If the tnsControls are hidden, hide the info and controls
    [info, controls].forEach(obj => {
      Object.keys(obj).forEach(key => {
        obj[key].style.display = isHidden ? 'none' : '';
      });
    });
    info.holder.style.display = isHidden ? 'none' : '';
  };
  const updateInfo = () => {
    const data = slider.getInfo();
    info.count.innerHTML = `${data.displayIndex} / ${data.slideCount}`;
    info.line.style.width = `${data.displayIndex / data.slideCount * 100}%`;
  };

  // When the slide is changed, remove all iframes from the block
  slider.events.on('indexChanged', updateInfo);

  // The extra next and previous buttons
  Object.keys(controls).forEach(key => {
    controls[key].addEventListener('click', () => slider.goTo(key));
  });
  Observer.observe(tnsControls, {
    attributes: true,
    attributeFilter: ['style']
  });
  updateInfo();
  showHide();
}
export default initSliderHeader;